import { IonPage, useIonViewWillEnter } from '@ionic/react';
import { RouteComponentProps } from 'react-router';

import { ProfileDoBWidget } from '../../widgets';
import { PrivateRoutes, PublicRoutes } from '../../routes/navigation';
import { useAuthFlow } from '../../shared';
import { AppHeader, IconArrowLeft, IconButton } from '@mindly/ui-components';
import React from 'react';
import { useSelector } from 'react-redux';
import { authStateSelector } from '../../redux/auth/selector';

type NeedUpdatePersonalDataProps = RouteComponentProps;

export function NeedUpdatePersonalDataDOBPage({ history }: NeedUpdatePersonalDataProps) {
  const authData = useSelector(authStateSelector);

  const { authUser } = useAuthFlow();

  useIonViewWillEnter(() => {
    if (!authUser) {
      history.push(PublicRoutes.AUTH);
      return;
    }
  }, []);

  return (
    <IonPage>
      <AppHeader className="flex flex-row items-start mb-4 cursor-pointer">
        <IconButton
          icon={<IconArrowLeft />}
          onClick={() =>
            history.push(
              authData.isNeedAdditionalData
                ? PrivateRoutes.NEED_UPDATE_PERSONAL_DATA_LAST_NAME
                : PrivateRoutes.NEED_UPDATE_PERSONAL_DATA
            )
          }
        />
      </AppHeader>
      <ProfileDoBWidget
        onSuccess={() => {
          history.push(PrivateRoutes.NEED_UPDATE_PERSONAL_DATA_COUNTRY_OF_LIVING);
        }}
      />
    </IonPage>
  );
}
